import * as React from 'react';
import { clsx as cx } from 'clsx';
import { TInputSize } from '@cian/ui-kit';

import { ControlInput } from '../ControlInput';
import { TControlProps, TRadioButtonTheme } from '../../types';

import * as styles from './styles.css';

export interface IControlButtonProps extends TControlProps {
  // NOTE: value может быть number
  value?: string | number;
  type: 'radio' | 'checkbox';
  label: string | number;
  size?: TInputSize;
  theme?: TRadioButtonTheme;
}

export const ControlButton = React.forwardRef(function ControlButton(
  props: IControlButtonProps,
  ref: React.Ref<HTMLLabelElement>,
) {
  const { disabled, invalid, label, size = 'M', theme = 'default' } = props;

  return (
    <ControlInput
      {...props}
      className={cx(
        styles['control-button'],
        styles[theme],
        disabled && styles['disabled'],
        invalid && styles['invalid'],
      )}
      ref={ref}
    >
      <span className={cx(styles['button'], styles[size.toLowerCase()])}>{label}</span>
    </ControlInput>
  );
});
